import { useEffect, useState } from 'react';
import { getUserFollows } from '../services/user-follow-service';

/**
 *
 * @param {Object} data
 * @param {Object} data.followType
 * @param {Object=} data.nestingParams
 * @returns
 */
const useFollowing = ({ followType, nestingParams = {} }) => {
  const [followingIds, setFollowingIds] = useState({});
  const [followsLoading, setFollowsLoading] = useState(true);
  const [followingFiltered, setFollowingFiltered] = useState(false);

  const [isNew, setIsNew] = useState(true);

  useEffect(() => {
    setFollowsLoading(true);
    (async () => {
      const follows = await getUserFollows({ followType, nestingParams });
      const typeFollows = follows[followType];
      if (typeFollows) {
        setFollowingIds(typeFollows);
        if (nestingParams?.sourceType && !isNew) {
          setFollowingFiltered(false);
        } else {
          setIsNew(false);
          setFollowingFiltered(Object.keys(typeFollows).length > 0);
        }
      }
      setFollowsLoading(false);
    })();
  }, [followType, JSON.stringify(nestingParams?.sourceType)]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    followingIds,
    setFollowingIds,
    followsLoading,
    followingFiltered,
    setFollowingFiltered,
  };
};

export default useFollowing;
